import { IAppState } from '../../../AppModulesWrapper';

import { EServiceId } from '../../types/reducers/publishTerms';
import { curry } from 'ramda';
import { IBetPosition } from '../../types/reducers/betPosition';

export const selectBetPositionByServiceId = curry((serviceId: EServiceId, state: IAppState): IBetPosition | null => {
  const {
    betPosition: { positionByService },
  } = state.servicePickerWidget;

  return positionByService[serviceId] || null;
});
